import { all } from 'redux-saga/effects';
import apiSaga from './saga/api';
import initialSaga from './saga/initial';
import localStorageSaga from './saga/localStorage';

export default function* rootSaga(): Generator {
  yield all([apiSaga(), initialSaga(), localStorageSaga()]);
}
